import React, { ReactElement, ReactNode } from "react";
import { Button, SearchIcon, Spinner } from "@src/components/elements";
import { StyledTableTitle } from "@src/components/modules/Table/StyledTable";
import { DownloadIcon } from "@src/components/elements/assets/DownloadIcon";
import { ExportCsvDataTrigger } from "@src/components/modules/Table/TableActions/ExportCsvData";
import { ButtonSize } from "@src/components/elements/ButtonVariants";

interface Props {
  title: string;
  canFilter: boolean;
  canExport: boolean;
  headerSlot: ReactNode;
  loading?: boolean;
  csvDownloadRef: React.Ref<ExportCsvDataTrigger>;
  toggleFilters?: () => void;
  buttonSize?: ButtonSize;
  exportPosition?: "left" | "right";
}

export const TableHeader = ({
  title,
  canFilter,
  canExport,
  headerSlot,
  loading,
  csvDownloadRef,
  toggleFilters,
  buttonSize = "medium",
  exportPosition = "right",
}: Props): ReactElement => {
  return (
    <>
      <header>
        <div className="header-left">
          {title ? <StyledTableTitle>{title}</StyledTableTitle> : null}
          {canFilter && (
            <div className="filter-menu" onClick={toggleFilters}>
              <Button variant="secondary" size={buttonSize}>
                <SearchIcon fill="var(--green)" />
                <span>Search / Filter</span>
              </Button>
            </div>
          )}
          {canExport && exportPosition === "left" ? (
            <Button
              variant="tertiary"
              size={buttonSize}
              onClick={() => {
                if (csvDownloadRef && "current" in csvDownloadRef)
                  csvDownloadRef?.current?.download();
              }}
            >
              Export
              <DownloadIcon />
            </Button>
          ) : null}
          {loading && <Spinner />}
        </div>
        <div className="header-right">
          <div className="header-slot">{headerSlot}</div>
          {canExport && exportPosition === "right" ? (
            <Button
              variant="tertiary"
              size={buttonSize}
              onClick={() => {
                if (csvDownloadRef && "current" in csvDownloadRef)
                  csvDownloadRef?.current?.download();
              }}
            >
              Export
              <DownloadIcon />
            </Button>
          ) : null}
        </div>
      </header>
    </>
  );
};
